<div class="modal fade" :id="modalComponentId" tabindex="-1" role="dialog" :aria-labelledby="modalComponentId + 'Label'" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" :id="modalComponentId + 'Label'">{{modalHeading}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="onModalCloseClick">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <loading-spinner :showSpinner="loading"></loading-spinner>
                <h4 v-if="!loading && !showErrorMessage">This Winner Is....</h4>
                <h4 v-if="!loading && !showErrorMessage">{{submission.firstName}} {{submission.lastName}}!</h4>
                
                <h4 class="text-danger" v-if="showErrorMessage">No submissions found for this campaign. Failed to draw a winner</h4>
            </div>
            <div class="modal-footer" v-if="!loading && !showErrorMessage">
                <button type="button" class="btn btn-secondary" @click="onViewSubmissionClick" :disabled="loading">View Submission</button>
            </div>
        </div>
    </div>
</div>